import(/* webpackMode: "eager" */ "/home/interim/frontend/app/services/hr-consulting/page.tsx");
